import { ExpandableTable } from "../../../components/UniversalTable";
import { defaultTableColumns } from "../../../helpers";
import { toMoney } from "shared/utils";
import { PayrollItem } from "../../../types/verified/payroll";
import { ContentTitle } from "views/applications-id-report/components/ContentTitle";
import { KeyValue } from "views/applications-id-report/components/KeyValue";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import {
  formatDate,
  formatDateRange,
  formatStartDate
} from "../../../utils/dateRange";

const getFullAddress = ({
  city,
  region,
  street,
  county,
  postal_code
}: {
  city?: string | null;
  region?: string | null;
  street?: string | null;
  county?: string | null;
  postal_code?: string | null;
}) => {
  const addressParts = [street, city, region, county, postal_code].filter(
    Boolean
  );

  return addressParts.length ? addressParts.join(", ") : " - ";
};

export const PayrollTable = ({ income }: { income: PayrollItem[] }) => {
  return (
    <ExpandableTable
      cellClassName="p-4 pl-0 text-sm self-center"
      headerRowClassName="text-content-300 font-medium"
      renderExpanded={({ original }) => {
        return (
          <div className="px-6 py-8 bg-background-900">
            <ContentTitle
              title="Employment details"
              contentClassName="space-y-2"
            >
              {/* 
              Missing
            Employment type
          */}
              <KeyValue
                label="Company name"
                value={original.data.employment.employer.name}
              />
              <KeyValue
                label="Company address"
                value={getFullAddress({
                  city: original.data.employment.employer.address?.city,
                  region: original.data.employment.employer.address?.region,
                  street: original.data.employment.employer.address?.street,
                  county: original.data.employment.employer.address?.county,
                  postal_code:
                    original.data.employment.employer.address?.postal_code
                })}
              />

              <KeyValue
                label="Job title"
                value={original.data.employment.title}
              />

              <KeyValue
                label="Status"
                value={
                  original.data.employment.status?.toUpperCase() ===
                  "ACTIVE" ? (
                    <Badge
                      variant={BadgeVariant.SUCCESS}
                      size={BadgeSize.SM}
                      borderless={false}
                    >
                      Active
                    </Badge>
                  ) : (
                    <Badge
                      variant={BadgeVariant.WARNING}
                      size={BadgeSize.SM}
                      borderless={false}
                    >
                      {original.data.employment.status}
                    </Badge>
                  )
                }
              />

              <KeyValue
                label="Start date"
                value={formatStartDate(original.data.start_date)}
              />

              <KeyValue
                label="Most recent pay date"
                value={formatDate(original.data.end_date)}
              />

              <KeyValue
                label="Gross annual income"
                value={toMoney(original.data.gross_monthly_income_amount * 12)}
              />

              <KeyValue
                label="Net annual income"
                value={toMoney(original.data.net_monthly_income_amount * 12)}
              />

              <KeyValue
                label="Pay frequency"
                value={
                  original.data.accounts?.length
                    ? original.data.accounts[0].pay_frequency
                    : "-"
                }
              />
            </ContentTitle>

            <ContentTitle title="Income summary" contentClassName="space-y-2">
              {/* Income start date
Income end date
Total net earnings */}

              <KeyValue
                label="Income start date"
                value={formatStartDate(original.data.start_date)}
              />
              <KeyValue
                label="Most recent pay date"
                value={formatDate(original.data.end_date)}
              />
              <KeyValue
                label="Total net earnings"
                value={toMoney(original.data.total_net)}
              />
            </ContentTitle>
          </div>
        );
      }}
      rows={income.map((item) => {
        const dateRange = formatDateRange(
          item.data.start_date,
          item.data.end_date
        );

        return {
          source: item.data.employment.employer.name || "",
          dateRange,
          grossMonthly: toMoney(item.data.gross_monthly_income_amount),
          netMonthly: toMoney(item.data.net_monthly_income_amount),
          original: item
        };
      })}
      columns={defaultTableColumns}
    />
  );
};
